module.exports = __webpack_public_path__ + "img/avatar2.8b3736cd.png";